import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Retail from "../../../assets/img/SolutionsIcons/AgilysysRetail.svg";
import { Header } from "../../../components/Header";

const RetailFPage = () => {
    return(
        <div className="page splash retailFPage">
            <div className="page-title"><img src={Retail} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                Our basic POS solution to support retail item sales for spas,
gift shops or pro-shops that don't need a full enterprise POS
system. Easily setup and track inventory, sell items as part of
other services, and consolidate it all on the guest folio.
                </div>
            </div>
            {/*<div className="play-video" onClick={()=>setShowVideo(true)}>
                <PlayTriangle />
                Play Video
            </div>*/}
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Retail1.png"} alt="" />
        </div>
    )
}

export default RetailFPage;